import script from "./VIconButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./VIconButton.vue?vue&type=script&lang=ts&setup=true"

import "./VIconButton.vue?vue&type=style&index=0&id=9d5ffe1e&lang=sass"

const __exports__ = script;

export default __exports__